<template>
  <div class="pa-2">
    <FormTemplateFieldSelector
      :templateID="$route.params.id"
      v-if="!loading && fieldSelecting"
      @select="fieldSelecting = false;editquestion.conditional_question_id = arguments[0].question_id; editquestion.conditional_fieldtype_id = arguments[0].fieldtype_id"
      @cancel="fieldSelecting = false"
    />
    <Preloader v-if="loading" />
    
    <div class="d-flex align-center justify-space-between mb-4" style="width: 100%;">
      <div class="d-flex align-center" style="min-width: 0; flex-shrink: 1; overflow: hidden;">
        <div class="text-h6 mr-4 text-truncate" style="min-width: 0;">Question Properties</div>
      </div>
      <div class="d-flex align-center flex-shrink-0 ml-2">
        <v-btn small text dense @click="$emit('cancel')">Cancel</v-btn>
        <v-btn small color="info" @click="saveForm" class="ml-2">Save</v-btn>
      </div>
    </div>

    <v-text-field
      v-model="editquestion.number"
      autofocus
      label="Number"
      v-on:keyup.enter="$refs.questionText.focus()"
      :hide-details="true"
      class="mb-4"
    />

    <v-text-field
      v-if="!htmlQuestion"
      ref="questionText"
      v-model="editquestion.text"
      label="Title"
      :hide-details="true"
      class="mb-2"
    />

    <div v-else class="mb-2">
      <div class="text-caption mb-1" style="color: rgba(0, 0, 0, 0.6);">Title</div>
      <Editor
        ref="titleHtmlEditor"
        :html="editquestion.text"
        style="background: white; border: 1px solid rgba(0,0,0,0.4); border-radius: 4px;"
      />
    </div>

    <v-btn
      text
      small
      class="mb-4 px-0"
      @click="toggleHtml()"
    >
      {{ htmlQuestion ? 'Edit as Plain Text' : 'Edit as HTML' }}
    </v-btn>

    <v-divider class="my-4" />

    <div class="text-subtitle-2 mb-2">Field Setup</div>
    <FieldType
      ref="fieldType"
      :fieldTypeId="fieldType.id"
      :minRows.sync="editquestion.min_rows"
      :defaultRows.sync="editquestion.default_rows"
      :maxRows.sync="editquestion.max_rows"
      :isList.sync="editquestion.is_list"
      :isListTable.sync="editquestion.is_list_table"
      :elFieldType="fieldTypePrint"
      :questionId="question.id"
      :newName.sync="tmpFtName"
      :newCLID="editFieldtype.clid != fieldType.clid ? editFieldtype.clid : null"
      @save="fieldTypeSaved"
      @loading="loading=arguments[0]"
      @selectReusable="editquestion.is_list = false"
    />

    <v-divider class="my-4" />

    <div class="text-subtitle-2 mb-2">Display Settings</div>
    <v-checkbox
      v-model="editquestion.web_only"
      label="Web Only"
      persistent-hint
      hint="Do not show question on PDF"
      class="mt-0 mb-2"
    />
    <v-checkbox
      v-model="editquestion.pdf_only"
      label="PDF Only"
      persistent-hint
      hint="Do not show on Web"
      class="mt-0 mb-2"
    />
    <v-checkbox
      v-model="editquestion.web_collapsible"
      label="Collapsible"
      persistent-hint
      hint="Allow users to collapse question"
      class="mt-0 mb-2"
    />
    <v-checkbox
      v-model="editquestion.read_only"
      label="Read Only"
      persistent-hint
      hint="Make this question read only to the contact."
      class="mt-0 mb-4"
    />

    <v-divider class="my-4" />

    <div class="text-subtitle-2 mb-2">Tip Dialog Text</div>
    <Editor
      :enable_formatting='editquestion.web_only'
      ref="tipHtmlEditor"
      :html="question.tip_text"
      style="background: white;"
    />

    <v-divider class="my-4" />

    <div class="text-subtitle-2 mb-2">Conditional Visibility</div>
    <v-checkbox
      v-model="conditional_part"
      label="Conditional Form Part"
      persistent-hint
      hint="Display part depending on answer to question"
      class="mt-0 mb-4"
    />

    <div v-if="conditional_part" class="pl-3" style="border-left: 2px solid #eee;">
      <v-text-field
        v-model="editquestion.conditional_question_id"
        label="Question ID"
        disabled
        class="mb-4"
      />
      <v-text-field
        v-model="editquestion.conditional_fieldtype_id"
        label="Fieldtype ID"
        disabled
        class="mb-4"
      />
      <v-text-field
        v-model="editquestion.conditional_value"
        label="Conditional Value"
        class="mb-4"
      />
      <v-checkbox
        v-model="editquestion.conditional_apply_pdf"
        label="Apply to PDF"
        persistent-hint
        hint="Hide from PDF if part fails condition"
        class="mt-0 mb-4"
      />
      <v-btn
        small
        outlined
        @click="fieldSelecting = true"
        class="mb-4"
      >
        Select a field
      </v-btn>
    </div>

    <v-divider class="my-4" />

    <div class="text-subtitle-2 mb-2">Custom IDs (Advanced)</div>
    <v-checkbox
      v-model="custom_clids"
      label="Custom CLIDs"
      persistent-hint
      hint="Change the Case Locker ID, must be 8 characters."
      class="mt-0 mb-4"
    />
    
    <div v-if="custom_clids" class="pl-3" style="border-left: 2px solid #eee;">
      <v-text-field
        v-model="editquestion.clid"
        label="Question CLID"
        :rules="clidRule"
        class="mb-4"
      />
      <v-text-field
        v-model="editFieldtype.clid"
        label="FieldType CLID"
        :rules="clidRule"
        class="mb-4"
      />
    </div>

    <v-btn
      v-if="isAdmin && fieldType.id && !fieldType.name"
      block
      outlined
      class="mb-4"
      @click="convertDialog = true"
    >
      Convert to Reusable
    </v-btn>

    <v-dialog
      v-model="convertDialog"
      :width="600"
      persistent
    >
      <v-card>
        <v-toolbar flat color="primary" dense dark>
          Convert to Reusable Fieldtype
        </v-toolbar>
        <v-card-text>
          Converting this fieldtype to a reusable fieldtype will allow it to be used in other questions and templates. <br /><br />
          To make edits to a reusable fieldtype, you must be an organization administrator.<br /><br /><hr /><br />To convert this fieldtype, create a name for it. You can set a description on the next page.
          <v-text-field
            v-model="tmpFtName"
            label="Name of Fieldtype"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="convertDialog = false">Cancel</v-btn>
          <v-btn
            :disabled="!tmpFtName"
            color="primary"
            @click="convertToFieldtype()"
          >
            Convert
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Preloader from '@/components/global/Preloader'
import FormTemplateFieldSelector from '@/components/admin/FormTemplateFieldSelector'
import FieldType from '../FieldType'
import Editor from '@/components/admin/Editor'

export default {
  name: 'QuestionProperties',
  props: [ 'partId', 'newPart' ],
  components: {
    Preloader,
    FormTemplateFieldSelector,
    FieldType,
    Editor
  },
  data () {
    return {
      editquestion: {},
      loading: false,
      htmlQuestion: false,
      displayAdditional: false,
      tempFt: {atomic_type_name: 'new'},
      convertDialog: false,
      tmpFtName: null,
      conditional_part: false,
      fieldSelecting: false,
      custom_clids: false,
      editFieldtype: {},
      clidRule: [
        value => !!value || 'A CLID is required',
        value => value.length <= 20 || "CLID needs to be 20 characters or less characters long"
      ]
    }
  },
  computed: {
    ...mapGetters('formtemplate', [
      'partById',
      'fieldTypeById'
    ]),
    ...mapGetters('auth', [
      'isAdmin',
    ]),
    question () {
      return this.partById(this.partId) || this.newPart
    },
    fieldType () {
      return this.fieldTypeById(this.question.fieldtype) || this.tempFt
    },
    fieldTypePrint () {
      if (this.fieldType.atomic_type_name) {
        if (this.fieldType.atomic_type_name === "number"){
          return "integer"
        }
        return this.fieldType.atomic_type_name
      }
      if (this.question.is_list) {
        return 'list'
      } else {
        return 'custom'
      }
    }
  },
  created () {
    this.editquestion = JSON.parse(JSON.stringify(this.question))
    this.editFieldtype = JSON.parse(JSON.stringify(this.fieldType))
    this.conditional_part = (this.editquestion.conditional_question_id)
    var htmlTag = /<[a-z][\s\S]*>/i
    if (htmlTag.test(this.editquestion.text)) {
      this.htmlQuestion = true
    }
  },
  methods: {
    ...mapActions('formtemplate', [
      'saveQuestion'
    ]),
    convertToFieldtype () {
      this.$refs.fieldType.save()
        .then(() => {
          this.$router.push({name: 'OrgSelectedFieldtype', params: {id: this.editquestion.fieldtype_id}})
        })
    },
    saveForm () {
      if ( this.fieldType.name ) {
        this.save()
      } else {
        this.loading = true
        this.$refs.fieldType.save()
          .then(() => {
            this.save()
          })
          .catch(() => {
            this.loading = false
          })
      }
    },
    fieldTypeSaved (fieldtype) {
      this.tempFt = fieldtype
      this.editquestion.fieldtype_id = fieldtype.id
    },
    toggleHtml () {
      if (this.htmlQuestion) {
        if (this.$refs.titleHtmlEditor) {
          const rawHtml = this.$refs.titleHtmlEditor.getHTML()
          const tempDiv = document.createElement('div')
          tempDiv.innerHTML = rawHtml
          this.editquestion.text = tempDiv.textContent || tempDiv.innerText || ''
        }
        this.htmlQuestion = false
      } else {
        this.htmlQuestion = true
      }
    },
    save () {
      this.loading = true
      if (this.htmlQuestion && this.$refs.titleHtmlEditor) {
        this.editquestion.text = this.$refs.titleHtmlEditor.getHTML()
      }
      this.editquestion.tip_text = this.getTipHTML()
      if(!this.conditional_part){
        this.editquestion.conditional_question_id = null
        this.editquestion.conditional_fieldtype_id = null
        this.editquestion.conditional_apply_pdf = false
        this.editquestion.conditional_value = ""
      }
      this.saveQuestion(this.editquestion)
      .then(question => {
        this.$emit('save', question)
        this.loading = false
        this.displayAdditional = false
        this.custom_clids = false
      })
      .catch(error => {
        this.loading = false
        if (error.response.status === 400) {
          this.errorMessages = JSON.parse(error.request.response)
        }
      })
    },
    saveHTML () {
      this.editquestion.text = this.$refs.htmlEditor.getHTML()
      this.editingHTML = false
      this.htmlQuestion = true
    },
    getTipHTML () {
      var html = this.$refs.tipHtmlEditor.getHTML()
      if (html.replace(/<\/?[^>]+(>|$)/g, "").replace(" ", "") !== "") {
        return this.$refs.tipHtmlEditor.getHTML()
      } else {
        return null
      }
    },
  }
}
</script>

<style scoped>
.adv_settings {
    padding:0 10px;
    padding: 0 25px 0 25px;
    border-top: 1px solid rgba(0,0,0,0.1)
}
</style>
